/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutoPayment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Notes from './Notes/index'
import React from 'react'
import TransactionId from './TransactionId/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function AutoPayment({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/PaymentMethod/AutoPayment"
  
}) {
let paymentValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
format: fromHelpers.getText,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let paymentSysCreatedValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
path: 'sys_created',
format: fromFormat.dateShortWithMonth,
})
let constantData = '.'
let aggregateData = fromAggregate.joinNoSpace(paymentSysCreatedValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="payment"
 format="helpers.js getText"
 text={paymentValueData}
/>
<TransactionId
  viewPath={`${viewPath}/TransactionId`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 text="on"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="payment.sys_created"
 format="/Data/format.js dateShortWithMonth"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
{children}
</React.Fragment>)
}